module.exports = __webpack_public_path__ + "img/Rashii-Givens.10388742.png";